module.exports = __webpack_public_path__ + "static/media/Tiger_Woods.395e7364.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Tiger_Woods.jpg
// module id = 417
// module chunks = 0